function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15 15.19H9",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M8.54 14.896a5.99 5.99 0 01-2.465-5.858c.406-2.607 2.579-4.688 5.2-4.995A6.001 6.001 0 0118 10a5.986 5.986 0 01-2.543 4.898 1.03 1.03 0 00-.457.835V18.5a2.5 2.5 0 01-2.5 2.5h-1A2.5 2.5 0 019 18.5v-2.763c0-.341-.182-.645-.46-.841z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20 5l1.19-1.19M4 15l-1.19 1.19M5 4L3.81 2.81M20 15l1.19 1.19M21 10h1.69M1.31 10H3M9 18h5.87",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgLightBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgLightBulb;